import React from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import Header from '../components/layout/Header';
import Footer from '../components/layout/Footer';

const ImpressumPage = () => {
  return (
    <div className="min-h-screen bg-white">
      <Header />
      <Helmet>
        <title>Impressum – unternehmenbewerten.ch</title>
        <meta name="description" content="Impressum der Schweizer Nachfolge Experten AG, Betreiberin von unternehmenbewerten.ch. Löwenstrasse 20, 8001 Zürich." />
        <link rel="canonical" href="https://www.unternehmenbewerten.ch/impressum" />
      </Helmet>
      
      <main className="pt-20">
        <section className="py-16 lg:py-24">
          <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
            {/* Breadcrumb */}
            <nav className="flex items-center gap-2 text-sm mb-8">
              <Link to="/" className="text-[#5a5d5b] hover:text-[#FF0000] transition-colors">Start</Link>
              <span className="text-[#888b89]">/</span>
              <span className="text-[#FF0000]">Impressum</span>
            </nav>

            <h1 className="text-4xl font-bold text-[#1a1c1b] mb-12">Impressum / Kontakt</h1>
            
            <div className="prose prose-lg max-w-none">
              {/* Kontakt */}
              <section className="mb-12">
                <h2 className="text-2xl font-bold text-[#1a1c1b] mb-4">unternehmenbewerten.ch</h2>
                <p className="text-[#5a5d5b] mb-4">Eine Dienstleistung der:</p>
                
                <div className="bg-[#f8f9fa] rounded-xl p-6 mb-8">
                  <p className="font-semibold text-[#1a1c1b] text-lg mb-2">Schweizer Nachfolge Experten AG</p>
                  <p className="text-[#5a5d5b]">c/o unternehmenbewerten.ch</p>
                  <p className="text-[#5a5d5b]">Löwenstrasse 20</p>
                  <p className="text-[#5a5d5b]">8001 Zürich</p>
                  <p className="text-[#5a5d5b]">Schweiz</p>
                </div>
              </section>

              {/* Haftungsausschluss */}
              <section className="mb-12">
                <h2 className="text-2xl font-bold text-[#1a1c1b] mb-4">Haftungsausschluss</h2>
                <p className="text-[#5a5d5b] mb-4">
                  Der Autor übernimmt keinerlei Gewähr hinsichtlich der inhaltlichen Richtigkeit, Genauigkeit, 
                  Aktualität, Zuverlässigkeit und Vollständigkeit der Informationen.
                </p>
                <p className="text-[#5a5d5b] mb-4">
                  Haftungsansprüche gegen den Autor wegen Schäden materieller oder immaterieller Art, welche 
                  aus dem Zugriff oder der Nutzung bzw. Nichtnutzung der veröffentlichten Informationen, durch 
                  Missbrauch der Verbindung oder durch technische Störungen entstanden sind, werden ausgeschlossen.
                </p>
                <p className="text-[#5a5d5b]">
                  Alle Angebote sind unverbindlich. Der Autor behält es sich ausdrücklich vor, Teile der 
                  Seiten oder das gesamte Angebot ohne gesonderte Ankündigung zu verändern, zu ergänzen, 
                  zu löschen oder die Veröffentlichung zeitweise oder endgültig einzustellen.
                </p>
              </section>

              {/* Haftung für Links */}
              <section className="mb-12">
                <h2 className="text-2xl font-bold text-[#1a1c1b] mb-4">Haftung für Links</h2>
                <p className="text-[#5a5d5b]">
                  Verweise und Links auf Webseiten Dritter liegen ausserhalb unseres Verantwortungsbereichs. 
                  Es wird jegliche Verantwortung für solche Webseiten abgelehnt. Der Zugriff und die Nutzung 
                  solcher Webseiten erfolgen auf eigene Gefahr des Nutzers oder der Nutzerin.
                </p>
              </section>

              {/* Urheberrechte */}
              <section className="mb-12">
                <h2 className="text-2xl font-bold text-[#1a1c1b] mb-4">Urheberrechte</h2>
                <p className="text-[#5a5d5b]">
                  Die Urheber- und alle anderen Rechte an Inhalten, Bildern, Fotos oder anderen Dateien auf 
                  der Website gehören ausschliesslich der Firma Schweizer Nachfolge Experten AG oder den 
                  speziell genannten Rechtsinhabern. Für die Reproduktion jeglicher Elemente ist die 
                  schriftliche Zustimmung der Urheberrechtsträger im Voraus einzuholen.
                </p>
              </section>
            </div>
          </div>
        </section>
      </main>
      
      <Footer />
    </div>
  );
};

export default ImpressumPage;
